<template>
  <v-system-bar app class="text-caption white--text" color="secondary">
    <v-img
      contain
      max-width="60"
      class="ml-5"
      :src="require('@/assets/osteon-logo-text.svg')"
    />
    <v-spacer />
    <span v-if="identity">
      <v-icon x-small color="white" v-if="identity.actor_type === 'client'">
        mdi-office-building
      </v-icon>
      <v-icon x-small color="white" v-if="identity.actor_type === 'employee'">
        mdi-account
      </v-icon>
      <v-icon x-small color="white" v-if="identity.actor_type === 'partner'">
        mdi-handshake
      </v-icon>
      {{ prettyIDName(identity) }}
    </span>
  </v-system-bar>
</template>

<script>
import { mapGetters } from "vuex"
import { prettyIDName } from "@/utils"

export default {
  name: "SystemBar",

  computed: {
    ...mapGetters(["identity"])
  },

  methods: {
    prettyIDName
  }
}
</script>
